import { useEffect, useRef } from "react";
import { getTopAchieversChanges } from "../actions/studensts";

// How often the Top Achievers pages ask the server for other users' saves.
const POLL_MS = 10000;

// Polls for Top Achievers edits (guests, event location, comment) saved by
// anyone since the previous poll and hands them to onChanges as
// [{ student_id, guests, event_location, comment }]. Polling (rather than a
// socket) because iisnode runs several Node processes that share nothing but
// the database. Pauses while the tab is hidden and catches up as soon as it is
// visible again.
export default function useTopAchieversLive(onChanges) {
  const onChangesRef = useRef(onChanges);
  onChangesRef.current = onChanges;

  useEffect(() => {
    let since = null;
    let timer = null;
    let stopped = false;
    let inFlight = false;

    const poll = async () => {
      if (stopped || inFlight || document.hidden) return;
      inFlight = true;
      const res = await getTopAchieversChanges(since);
      inFlight = false;
      if (stopped) return;
      if (res && res.status === 200) {
        // now is null until the top_achievers_changes table exists.
        if (res.data?.now) since = res.data.now;
        const changes = res.data?.changes || [];
        if (changes.length) onChangesRef.current(changes);
      }
    };

    const schedule = () => {
      timer = setTimeout(async () => {
        await poll();
        if (!stopped) schedule();
      }, POLL_MS);
    };

    const onVisible = () => {
      if (!document.hidden) poll();
    };

    poll();
    schedule();
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      stopped = true;
      clearTimeout(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);
}
